import { Product, PagerItem } from '@/types';

export type State = {
    isLoading: boolean;
    items: Product[] | [];
    pager: PagerItem[];
    nextPageUrl: string | null;
    nextPageLabel: string;
    backToTopLabel: string;
}

export const state: State = {
    isLoading: false,
    items: [],
    pager: [],
    nextPageUrl: null,
    nextPageLabel: "",
    backToTopLabel: ""
};
